<template>
  <v-stepper-content
    :step="step">
    <v-card
      flat>
      <v-card-title
        v-if="title">
        <span>{{ title }}</span>
      </v-card-title>

      <v-card-text>
        <slot />
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="!hideButtonBack"
          :disabled="!canNavigateBack"
          text
          @click="back">
          {{ labelButtonBack }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!hideButtonForward"
          :disabled="!canNavigateForward"
          depressed
          color="primary"
          @click="next">
          {{ labelButtonForward }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-stepper-content>
</template>

<script>
export default {
  name: 'WizardPage',

  props: {
    step: {
      type: Number,
      default: void 0,
      required: true
    },

    title: {
      type: String,
      default: void 0
    },

    hideButtonBack: {
      type: Boolean,
      default: false
    },

    hideButtonForward: {
      type: Boolean,
      default: false
    },

    canNavigateBack: {
      type: Boolean,
      default: false
    },

    canNavigateForward: {
      type: Boolean,
      default: false
    },

    labelButtonBack: {
      type: String,
      default: 'Zurück'
    },

    labelButtonForward: {
      type: String,
      default: 'Weiter'
    }
  },

  methods: {
    next () {
      // this.$emit('next')
      // yeah, hacky.
      this.$parent.$parent.$parent.onNext(this.$parent)
    },

    back () {
      // this.$emit('back')
      // yeah, hacky.
      this.$parent.$parent.$parent.onBack(this.$parent)
    }
  }
}
</script>
